module.exports = require('./lib/speakingurl');



//////////////////
// WEBPACK FOOTER
// ./node_modules/speakingurl/index.js
// module id = 161
// module chunks = 1